import React, { useEffect, useState, useRef, useMemo } from "react";
import { Link } from "react-router-dom";
import withRouter from "components/Common/withRouter";
import TableContainer from "../../../components/Common/TableContainer";
import {
  Card,
  CardBody,
  Col,
  Container,
  Row,
  Modal,
  ModalHeader,
  ModalBody,
  Label,
  FormFeedback,
  UncontrolledTooltip,
  Input,
  Form,
} from "reactstrap";
import * as Yup from "yup";
import { useFormik } from "formik";
import { NameSurname, NumberCell, Status } from "./contactlistCol";

import Breadcrumbs from "components/Common/Breadcrumb";
import DeleteModal from "components/Common/DeleteModal";

// redux actions — QuizTemplateItem + QuizTemplate
import {
  getProductCategory as ongetProductCategory,
  addProductCategory as onAddProductCategory,
  updateProductCategory as onUpdateProductCategory,
  deleteProductCategory as onDeleteProductCategory,
  getQuizTemplates as onGetQuizTemplates,
} from "store/contacts/actions";

import { useSelector, useDispatch } from "react-redux";

const QuizTemplateItemList = () => {
  const tableRef = useRef(null);
  document.title = "QuizTemplateItem | Bee Education ADMIN PANELI";

  const dispatch = useDispatch();

  // store'dan listeler
  const { items, quizTemplates } = useSelector((state) => ({
    items: state.contacts.productCategory || [],       // <-- DÜZELTİLDİ
    quizTemplates: state.contacts.quizTemplates || [],
  }));

  // UI state
  const [modal, setModal] = useState(false);
  const [deleteModal, setDeleteModal] = useState(false);
  const [editingRow, setEditingRow] = useState(null);
  const [rowForDelete, setRowForDelete] = useState(null);
  const [isEdit, setIsEdit] = useState(false);
  const [isActive, setIsActive] = useState(false);

  // parent id (select)
  const [quizTemplateId, setQuizTemplateId] = useState("");

  // parent adını çözen yardımcı (QuizTemplate.Name varsayımı)
  const resolveTemplateName = (row) =>
    row?.QuizTemplate?.Name ||
    row?.QuizTemplate_Name ||
    quizTemplates.find((t) => String(t.ID) === String(row?.QuizTemplateID))?.Name ||
    "-";

  // form
  const validation = useFormik({
    enableReinitialize: true,
    initialValues: {
      title: editingRow?.Title || "",
      slotNo: editingRow?.SlotNo ?? "",
    //  questionCount: editingRow?.QuestionCount.toString() ?? "",
   //   levelMask: editingRow?.LevelMask.toString() ?? "",
      quizTemplateId: editingRow?.QuizTemplateID ?? quizTemplateId ?? "",
    },
    validationSchema: Yup.object({
      title: Yup.string().required("Başlık giriniz"),
      quizTemplateId: Yup.number().typeError("Şablon seçiniz").required("Şablon seçiniz"),
      slotNo: Yup.number().typeError("Slot No sayı olmalı").nullable(),
     // questionCount: Yup.number().typeError("Soru sayısı sayı olmalı").nullable(),
      // levelMask: Yup.number().typeError("Level mask sayı olmalı").nullable(),
    }),
    onSubmit: (values) => {
      const payload = {
        Title: values.title,
        QuizTemplateID: Number(values.quizTemplateId),
        SlotNo: values.slotNo !== "" ? Number(values.slotNo) : null,
        QuestionCount: values.questionCount !== "" ? Number(values.questionCount) : null,
        LevelMask: values.levelMask !== "" ? Number(values.levelMask) : null,
        IsActive: isActive,
      };

      console.log("12312payload",payload)
      if (isEdit && editingRow?.ID) {
        dispatch(onUpdateProductCategory({ ID: editingRow.ID, ...payload }));
      } else {
        dispatch(onAddProductCategory(payload));
      }

      validation.resetForm();
      setIsEdit(false);
      setEditingRow(null);
      toggle();
    },
  });

  // kolonlar
  const columns = useMemo(
    () => [
      {
        Header: "#",
        Cell: () => <input type="checkbox" className="form-check-input" />,
      },
      {
        Header: "Başlık",
        accessor: "Title",
        filterable: true,
        Cell: (cellProps) => <NameSurname {...cellProps} />,
      },
      {
        Header: "QuizTemplate",
        accessor: "QuizTemplateID",
        filterable: true,
        Cell: (cellProps) => <span>{resolveTemplateName(cellProps.row.original)}</span>,
      },
      {
        Header: "Slot No",
        accessor: "SlotNo",
        filterable: true,
        Cell: (cellProps) => <NameSurname {...cellProps} />,
      },
     
      {
        Header: "İşlemler",
        Cell: (cellProps) => {
          const row = cellProps.row.original;
          return (
            <div className="d-flex gap-3">
              <Link
                to="#"
                className="text-success"
                onClick={() => handleEditClick(row)}
              >
                <i className="mdi mdi-pencil font-size-18" id="edittooltip" />
                <UncontrolledTooltip placement="top" target="edittooltip">
                  Düzenle
                </UncontrolledTooltip>
              </Link>
              <Link
                to="#"
                className="text-danger"
                onClick={() => onClickDelete(row)}
              >
                <i className="mdi mdi-delete font-size-18" id="deletetooltip" />
                <UncontrolledTooltip placement="top" target="deletetooltip">
                  Sil
                </UncontrolledTooltip>
              </Link>
            </div>
          );
        },
      },
    ],
    [quizTemplates]
  );

  // ilk yükleme
  useEffect(() => {
    dispatch(ongetProductCategory()); // item listesi
    dispatch(onGetQuizTemplates());     // parent dropdown
  }, [dispatch]);

  const toggle = () => setModal(!modal);

  const handleAddClick = () => {
    setEditingRow(null);
    setIsEdit(false);
    setIsActive(false);
    setQuizTemplateId("");
    validation.resetForm();
    toggle();
  };

  const handleEditClick = (row) => {
    setEditingRow(row);
    setIsEdit(true);
    setIsActive(!!row.IsActive);
    setQuizTemplateId(row.QuizTemplateID || "");
    validation.setValues({
      title: row.Title || "",
      slotNo: row.SlotNo ?? "",
      questionCount: row.QuestionCount ?? "",
      levelMask: row.LevelMask ?? "",
      quizTemplateId: row.QuizTemplateID || "",
    });
    toggle();
  };

  const onClickDelete = (row) => {
    setRowForDelete(row);
    setDeleteModal(true);
  };

  const handleDelete = () => {
    if (rowForDelete?.ID) {
      dispatch(onDeleteProductCategory(rowForDelete.ID));
    }
    setDeleteModal(false);
    setRowForDelete(null);
  };

  const onChangeTemplate = (e) => {
    const val = e.target.value;
    setQuizTemplateId(val);
    validation.setFieldValue("quizTemplateId", val);
  };

  return (
    <React.Fragment>
      <DeleteModal
        show={deleteModal}
        onDeleteClick={handleDelete}
        onCloseClick={() => setDeleteModal(false)}
      />

      <div className="page-content">
        <Container fluid>
          <Breadcrumbs title="Yönetim" breadcrumbItem="QuizTemplateItem Listesi" />

          <Row>
            <Col lg="12">
              <Card>
                <CardBody>
                  <TableContainer
                    columns={columns}
                    data={items || []}
                    ref={tableRef}
                    isGlobalFilter={true}
                    isAddQuizTemplateItem={true}   // TableContainer bu prop’u dinlemiyorsa, sende kullanılan add buton prop adını ver
                    handleOrderClicks={handleAddClick}
                    customPageSize={10}
                    className="custom-header-css"
                  />

                  <Modal isOpen={modal} toggle={toggle}>
                    <ModalHeader toggle={toggle} tag="h4">
                      {isEdit ? "Düzenle" : "QuizTemplateItem Ekle"}
                    </ModalHeader>
                    <ModalBody>
                      <Form
                        onSubmit={(e) => {
                          e.preventDefault();
                          validation.handleSubmit();
                          return false;
                        }}
                      >
                        <Row>
                          <Col xs={12}>
                                 <div className="mb-3">
                              <Label className="form-label">QuizTemplate</Label>
                              <Input
                                name="quizTemplateId"
                                type="select"
                                className="form-select"
                                value={validation.values.quizTemplateId || ""}
                                onChange={onChangeTemplate}
                              >
                                <option value="">Lütfen Seçim Yapınız</option>
                                {(quizTemplates || []).map((t) => (
                                  <option value={t.ID} key={t.ID}>
                                    {t.Name}
                                  </option>
                                ))}
                              </Input>
                              {validation.touched.quizTemplateId &&
                              validation.errors.quizTemplateId ? (
                                <div className="invalid-feedback d-block">
                                  {validation.errors.quizTemplateId}
                                </div>
                              ) : null}
                            </div>
                            
                            <div className="mb-3">
                              <Label className="form-label">Başlık</Label>
                              <Input
                                name="title"
                                type="text"
                                placeholder="Item başlığı"
                                onChange={validation.handleChange}
                                onBlur={validation.handleBlur}
                                value={validation.values.title || ""}
                                invalid={!!(validation.touched.title && validation.errors.title)}
                              />
                              {validation.touched.title && validation.errors.title ? (
                                <FormFeedback type="invalid">
                                  {validation.errors.title}
                                </FormFeedback>
                              ) : null}
                            </div>

                     

                            <div className="mb-3">
                              <Label className="form-label">Slot No</Label>
                              <Input
                                name="slotNo"
                                type="number"
                                placeholder="Sıradaki slot (opsiyonel)"
                                onChange={validation.handleChange}
                                onBlur={validation.handleBlur}
                                value={validation.values.slotNo || ""}
                                invalid={!!(validation.touched.slotNo && validation.errors.slotNo)}
                              />
                              {validation.touched.slotNo && validation.errors.slotNo ? (
                                <FormFeedback type="invalid">
                                  {validation.errors.slotNo}
                                </FormFeedback>
                              ) : null}
                            </div>
                            {/** 
                            <div className="mb-3">
                              <Label className="form-label">Soru Sayısı</Label>
                              <Input
                                name="questionCount"
                                type="number"
                                placeholder="Bu item için soru adedi (opsiyonel)"
                                onChange={validation.handleChange}
                                onBlur={validation.handleBlur}
                                value={validation.values.questionCount || ""}
                                invalid={!!(validation.touched.questionCount && validation.errors.questionCount)}
                              />
                              {validation.touched.questionCount && validation.errors.questionCount ? (
                                <FormFeedback type="invalid">
                                  {validation.errors.questionCount}
                                </FormFeedback>
                              ) : null}
                            </div>*/}
                            {/** 
                            <div className="mb-3">
                              <Label className="form-label">Level Mask</Label>
                              <Input
                                name="levelMask"
                                type="number"
                                placeholder="Seviye mask (örn: B1=1, B1+=2, B2=4 …)"
                                onChange={validation.handleChange}
                                onBlur={validation.handleBlur}
                                value={validation.values.levelMask || ""}
                                invalid={!!(validation.touched.levelMask && validation.errors.levelMask)}
                              />
                              {validation.touched.levelMask && validation.errors.levelMask ? (
                                <FormFeedback type="invalid">
                                  {validation.errors.levelMask}
                                </FormFeedback>
                              ) : null}
                            </div>


                             <div className="square-switch">

                            <input
                              type="checkbox"
                              id="square-switch1"
                              className="switch"
                              defaultChecked={isActive}
                              onChange={() =>
                                setIsActive(!isActive)
                              }
                            />
                            <label
                         htmlFor="square-switch1"
                              data-on-label="Aktif "
                              data-off-label="Pasif"
                            />
                          </div>
                        */}
                          
                      
                          </Col>
                        </Row>

                        <Row>
                          <Col>
                            <div className="text-end">
                              <button type="submit" className="btn btn-success save-user">
                                Kaydet
                              </button>
                            </div>
                          </Col>
                        </Row>
                      </Form>
                    </ModalBody>
                  </Modal>
                </CardBody>
              </Card>
            </Col>
          </Row>
        </Container>
      </div>
    </React.Fragment>
  );
};

export default withRouter(QuizTemplateItemList);
